import React from 'react';
import { IVideo } from '../../pages/admin/videos/hooks/useFetchVideos';
import placeholder from '../../assets/video_placeholder.png';

/**
 * The card's thumbnail pieces, kept in a leaf module so lightweight video
 * lists (the review modal's apply-comment picker) can reuse them without
 * importing VideoCard, whose menu imports the review modal back.
 */

/** Play glyph painted under the thumbnail; shows through when it fails. */
export const PLAY_GLYPH = (size: number) => (
  <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="9.2" />
    <path d="m10.2 8.6 5.4 3.4-5.4 3.4z" />
  </svg>
);

export const thumbSource = (video: IVideo): string => {
  if (!(video.key || video.s3Location)) return placeholder;
  const url = video.location || video.reviewS3File?.location || '';
  if (url && url.includes('.mp4')) return url.replace('.mp4', '_thumbnail.png');
  return url || placeholder;
};
